module.exports = __webpack_public_path__ + "img/Z85-X18-中_16.c04a62cb.jpg";